<template>
  <div
    v-if="model.referrer_host"
    ref="hostRef"
    v-tooltip="{
      content: model?.referrer_absolute_url,
    }"
    class="overflow-hidden text-xs text-ellipsis whitespace-nowrap text-label"
  >
    {{ model.referrer_host }}...
  </div>
  <div v-else>-</div>
</template>
<script setup lang="ts">
const { model } = defineProps<{
  model: { referrer_absolute_url: string; referrer_host: string };
}>();
</script>
